module.exports = __webpack_public_path__ + "static/media/om-drawer-mf-ikon@3x.2b95c2e9.png";